import React, { useContext } from 'react';
import { isEmpty } from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { DWTCContext } from '../utils/context';
import { getTranslationByKey } from '../helpers/translation-helper';
import {
  TwoContentWrapper,
  Description,
  ExploreButton,
  Header,
  ReadMore,
  ReadMoreWrapper,
  Title,
  SectionCaption,
  LeftImageCenter,
  ExploreButtonCTA,
} from './styles/AboutVenue.styled';
import { Container } from './styles/Container.styled';
import { Row } from './styles/Row.styled';
import { ColumnXlSevenlgSix, Column, Innercontent } from './styles/Column.styled';
import useMediaQuery from '../hooks/useMediaQuery';

export default function AboutVenue({ data, dir, id }) {
  const { title, header, contentParagraphs, image, link } = data;
  const [readMore, setReadMore] = React.useState(false);

  const { translations } = useContext(DWTCContext);

  const textLess = getTranslationByKey(translations, '-Read Less');
  const textMore = getTranslationByKey(translations, '+Read More');

  const readMoreLabel = readMore ? textLess : textMore;

  const variants = {
    hidden: { opacity: 0, y: -100, height: 0 },
    visible: { opacity: 1, y: 0, height: 'auto' },
  };

  const matches = useMediaQuery('(min-width: 576px)');

  const handleAnimate = (index) => {
    if (matches) {
      return 'visible';
    }
    return index && readMore ? 'visible' : 'hidden';
  };

  return (
    <TwoContentWrapper id={id}>
      <Container>
        <SectionCaption dir={dir}>
          <Title dir={dir}>{title}</Title>
        </SectionCaption>

        <Row>
          <Column>
            <Innercontent className="margin-left0 newdevelopmentcontent content_wrapper" dir={dir}>
              <Header dir={dir}>{header}</Header>
              {contentParagraphs.map((text, index) =>
                index ? (
                  <Description
                    dir={dir}
                    variants={variants}
                    animate={handleAnimate(index)}
                    initial={matches ? 'visible' : 'hidden'}
                    transition={{ duration: 0.5, ease: 'linear' }}
                  >
                    {text}
                  </Description>
                ) : (
                  <Description dir={dir}>{text}</Description>
                ),
              )}
              <ReadMoreWrapper>
                <ReadMore dir={dir} onClick={() => setReadMore(!readMore)}>
                  {readMoreLabel}
                </ReadMore>
              </ReadMoreWrapper>
              {isEmpty(link) || (
                <ExploreButtonCTA dir={dir} className="hidden_smscreen">
                  <ExploreButton dir={dir} href={isEmpty(link) ? '#0' : link.url}>
                    {link.name}
                  </ExploreButton>
                </ExploreButtonCTA>
              )}
            </Innercontent>
          </Column>
          <ColumnXlSevenlgSix className="padding_lftrgt">
            <LeftImageCenter>
              {isEmpty(image) || (
                <LazyLoadImage
                  src={image.url}
                  alt={image.name}
                  className="width_100"
                  placeholderSrc={image ? `${image.url}?width=50&quality=50` : null}
                  effect="blur"
                />
              )}

              {isEmpty(link) || (
                <ExploreButtonCTA dir={dir} className="small_screenbutton">
                  <ExploreButton dir={dir} href={isEmpty(link) ? '#0' : link.url}>
                    {link.name}
                  </ExploreButton>
                </ExploreButtonCTA>
              )}
            </LeftImageCenter>
          </ColumnXlSevenlgSix>
        </Row>
      </Container>
    </TwoContentWrapper>
  );
}